import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SwitchListItem from '../../../../../list-items/SwitchListItem/SwitchListItem';

const TextBoldListItem = (props) => {
    const { textElementBold, index, updateTextElement } = props;
    const onBoldStyleChange = (event) => updateTextElement(index, { bold: event.target.checked });
    
    return (
        <SwitchListItem
            text='Bold'
            checked={textElementBold}
            onChange={onBoldStyleChange}
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const { bold: textElementBold } = state.createPreview.present.videoSettings.text.textElements[ownProps.index];
    return { textElementBold };
}

const mapDispatchToProps = (dispatch) => {
    const updateTextElement = (index, properties) => dispatch(createActions.updateTextElement(index, properties));
    return { updateTextElement }
}

export default connect(mapStateToProps, mapDispatchToProps)(TextBoldListItem);